// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"1244c56a","455":"b7a419a7","977":"0771b3a1"}[chunkId] + ".chunk.js");